import React from 'react'
import '../static/style/header.css'
import GitHubIcon from '@mui/icons-material/GitHub';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import img from '../static/images/headerimg.png'

import cv from '../files/cv__bekkar__merwan.pdf'

function Header() {
  return (
    <div className='header'>
        <div className='right'>
            <div className='email'>
                <a href="mailto:merwan.bekkar22@gmail.com">merwan.bekkar22@gmail.com</a>    
            </div>
        </div>
        <div className='left'>
            <ul className='icons'>
                <li>
                    <a href="https://github.com/merwan32">
                        <GitHubIcon />
                    </a>
                </li>  
                <li>
                    <a href="https://www.linkedin.com/in/bekkar-merwan-9b6559247/?locale=en_US">
                        <LinkedInIcon />
                    </a>
                </li> 
                <li>
                    <a href="https://www.instagram.com/bk__mrwan/">
                        <InstagramIcon />
                    </a>
                </li> 
                <li>
                    <a href="https://web.facebook.com/mer.wan.37625">
                        <FacebookOutlinedIcon />
                    </a>
                </li> 
            </ul>
        </div>
        <div className='header-right'>
            <div >
                <h1>Hi, my name is</h1>
            </div>
            <div >
                <h2>Bekkar Merwan</h2>
            </div>
            <div >
                <p>I’m a software engineer specializing in building web applications with React and Django. Currently, I’m focused to learn data science.</p>
            </div>
            <a href={cv} target="_blank" type="application/pdf"><button>Check out my CV</button></a> 
        </div>
        <div className='header-left'>
            <img src={img}/>
        </div>
    </div>
  )
}

export default Header